import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NovaPoshtaCity, NovaPoshtaDeliveryKind, NovaPoshtaWarehouse } from 'src/typings';

@Injectable({
  providedIn: 'root'
})
export class NovaPoshtaService {
  constructor(private http: HttpClient) {}

  searchCities(query: string, limit = 20) {
    const params = new HttpParams().set('q', query).set('limit', String(limit));
    return this.http.get<NovaPoshtaCity[]>(`${environment.BACKEND}/nova-poshta/cities`, {
      params
    });
  }

  searchWarehouses(payload: {
    cityRef: string;
    kind: NovaPoshtaDeliveryKind;
    query?: string;
    limit?: number;
    page?: number;
  }) {
    let params = new HttpParams()
      .set('cityRef', payload.cityRef)
      .set('kind', payload.kind)
      .set('limit', String(payload.limit || 20))
      .set('page', String(payload.page || 1));

    if (payload.query) {
      params = params.set('q', payload.query);
    }

    return this.http.get<NovaPoshtaWarehouse[]>(
      `${environment.BACKEND}/nova-poshta/warehouses`,
      { params }
    );
  }
}
